import { customFieldCategory } from "../../../../constants/formBuilder";

export const paths = {
  EVENT: "event",
  EVENT_ID: "eventId",
  PROGRAM_NAME: "name",
  IS_ACTIVE: "isActive",
  FUNDRAISER_MINIMUM_TARGET_AMOUNT: "fundraiserMinimumTargetAmount",
  CURRENCY: "currency",
  CURRENCY_TARGETS: "currencyTargets",
  FUNDRAISING_GUARANTEE_ENABLED: "donationPlan.enabled",
  FUNDRAISING_GUARANTEE_COUNTRIES: "donationPlan.countries",
  REGISTRATION_FEE_ENABLED: "registrationFee.enabled",
  REGISTRATION_FEE_COUNTRIES: "registrationFee.countries",
  CHARITY_COUNTRIES: "charityCountries",
  DEFAULT_AMBASSADOR_STATUS: "defaultAmbassadorStatus",
  PAGE_CREATION_STATUS: "pageCreationOption",
  FLOW: "flow",
  DATE_APPLICATIONS_OPEN: "startsAt",
  DATE_APPLICATIONS_CLOSE: "newEntriesEndAt",
  DATE_CLAIMS_CLOSE: "endsAt",
  FUNDRAISING_FIELDS_OVERRIDE: "allowCampaignFundraiserOverrides",
  FUNDRAISING_DEADLINE_DATE: "fundraiseBy",
  TERMINOLOGY: "participantName",
  BANNER: "mainImagePath",
  INTRO_TEXT: "description",
  APPLICATION_ENTRY: `template.value.formBuilder.${customFieldCategory.ENTRY}`,
  APPLICATION_CONFIRMATION: `template.value.formBuilder.${customFieldCategory.CONFIRMATION}`,
  APPLICATION_RECEIVED: "emailSettings.newEmailCustomText",
  APPLICATION_ACCEPTED: "emailSettings.acceptedEmailCustomText",
  APPLICATION_REJECTED: "emailSettings.rejectedEmailCustomText",
  SIGNATURE_VERIFICATION_ENABLED: "template.value.enableSignature",
  TERMS_AND_CONDITIONS_ENABLED:
    "template.value.termsAndConditionSetup.allowTermsAndConditions",
  TERMS_AND_CONDITIONS_TITLE: "template.value.termsAndConditionSetup.title",
  TERMS_AND_CONDITIONS_LINK: "template.value.termsAndConditionSetup.link",
  WAIVERS_ENABLED: "template.value.termsAndConditionSetup.allowWaivers",
  WAIVERS: "template.value.termsAndConditionSetup.waivers",
  ANNOUNCEMENT: "template.value.announcement",
  ANNOUNCEMENT_ENABLED: "template.value.announcement.enabled",
  ANNOUNCEMENT_TITLE: "template.value.announcement.title",
  ANNOUNCEMENT_DESCRIPTION: "template.value.announcement.description",
  ANNOUNCEMENT_CALL_TO_ACTION: "template.value.announcement.callToAction",
  ANNOUNCEMENT_LINK: "template.value.announcement.link"
};
